import {TrackingDeliveryStatus} from 'types/tracking';
import {
  CompletedBadgeIcon,
  DeliveringBadgeIcon,
  CanceledBadgeIcon,
  DefaultBadgeIcon,
} from 'pages/Tracking/icons';

type Props = {
  status: TrackingDeliveryStatus;
};

export const StatusIcon = ({status}: Props) => {
  switch (status) {
    case 'completed':
      return <CompletedBadgeIcon />;
    case 'delivering':
      return <DeliveringBadgeIcon />;
    case 'canceled':
      return <CanceledBadgeIcon />;
    default:
      return <DefaultBadgeIcon />;
  }
};
